import React from 'react';
import { Backdrop, Box, CircularProgress, Typography, Fade } from '@mui/material';

interface TransitionOverlayProps {
    open: boolean;
    message?: string;
    subMessage?: string;
    onComplete?: () => void;
}

export const TransitionOverlay: React.FC<TransitionOverlayProps> = ({
    open,
    message = "Loading...",
    subMessage = "",
    onComplete
}) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.modal + 1,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(4px)',
            }}
            open={open}
        >
            <Fade in={open} timeout={300}>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    gap: 3,
                    color: '#333',
                    textAlign: 'center',
                    padding: 4
                }}>
                    <Box sx={{ position: 'relative' }}>
                        <CircularProgress 
                            size={60} 
                            sx={{ 
                                color: '#1a5dbd',
                                '& .MuiCircularProgress-circle': {
                                    strokeLinecap: 'round',
                                }
                            }} 
                        />
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>

                        </Box>
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                            {message}
                        </Typography>
                        <Typography variant="body1" sx={{ opacity: 0.7 }}>
                            {subMessage}
                        </Typography>
                    </Box>
                </Box>
            </Fade>
        </Backdrop>
    );
};

// Hook for managing transition states
export const useTransition = () => {
    const [isTransitioning, setIsTransitioning] = React.useState(false);
    const [transitionMessage, setTransitionMessage] = React.useState("Loading...");

    const startTransition = (message?: string, delay: number = 150) => {
        if (message) setTransitionMessage(message);
        setIsTransitioning(true);
        
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                resolve();
            }, delay);
        });
    };

    const endTransition = () => {
        setIsTransitioning(false);
    };

    return {
        isTransitioning,
        transitionMessage,
        startTransition,
        endTransition
    };
}; 